import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { delete_icon, edit_icon, search_icon, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBannerDeleteMutation, useBannerListMutation, } from '../redux/api/api';
import moment from 'moment/moment';
import { toast } from 'react-toastify';

const Banners = () => {
    const navigate = useNavigate();
    const [deletePopup, setDeletePopup] = useState(false);
    const [list, setList] = useState([]);
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");
    const [Id, setId] = useState('')



    const rolePermissions = JSON.parse(localStorage.getItem('permissions'))


    const [bannerListApi] = useBannerListMutation();
    const [bannerDeleteApi] = useBannerDeleteMutation();

    const bannerList = (page, search) => {
        const formdata = new FormData();
        formdata.append("page", page)
        formdata.append("row", 10)
        if (search) {
            formdata.append('search', search)
        }
        bannerListApi(formdata)
            .unwrap()
            .then((res) => {

                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setPagecount(res?.pagination)
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const bannerDelete = (id) => {
        const formdata = new FormData();
        formdata.append("_method", "DELETE");
        bannerDeleteApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    setDeletePopup(false);
                    bannerList();
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }


    useEffect(() => {
        bannerList(pageno)
    }, [pageno]);


    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>;
                }
            },
            {
                Header: "Country",
                accessor: "country",
                Cell: ({ value, row }) => {
                    return <p>{value?.name}</p>;
                },
            },
            {
                Header: "State",
                accessor: "state",
                Cell: ({ value, row }) => {
                    return <p>{value?.name}</p>;
                },
            },
            {
                Header: "City",
                accessor: "city",
                Cell: ({ value, row }) => {
                    return <p>{value?.name}</p>;
                },
            },
            {
                Header: "From Date",
                accessor: "start_datetime",
                Cell: ({ value, row }) => {
                    // Convert the date using moment and format it
                    return <p>{moment(value).format("DD-MM-YYYY ")}</p>; // Adjust the format as per your requirement
                }
            },
            {
                Header: "To Date",
                accessor: "end_datetime",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format("DD-MM-YYYY ")}</p>;
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">
                                {rolePermissions?.includes('CAN-VIEW-MASTER') &&
                                    <button
                                        onClick={() => { navigate('/add-banners', { state: { id: row.original.id, type: "view" } }) }}
                                        className="cust-btn "
                                    >
                                        <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                                {rolePermissions?.includes('CAN-EDIT-MASTER') &&
                                    <button
                                        onClick={() => { navigate('/add-banners', { state: { id: row.original.id, type: "edit" } }) }}
                                        className="cust-btn "
                                    >
                                        <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                                {rolePermissions?.includes('CAN-DELETE-MASTER') &&
                                    <button
                                        onClick={() => setDeletePopup(row.original.id)}
                                        className="cust-btn "
                                    >
                                        <img src={delete_icon} alt="" className="mx-2 edit-btn " />
                                    </button>}
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Masters - Banners
                </h2>
                <div className='d-flex gap-3'>
                    < div className='search-input'>
                        <input onChange={(e) => bannerList(1, e.target.value)} type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
                        <img src={search_icon} className='search' />
                    </div>
                    {rolePermissions?.includes('CAN-ADD-MASTER') &&
                    <button onClick={() => navigate('/add-banners', { state: { type: "add", id: Id } })} className='f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn '> + Add </button>}
                </div>
            </div>
            <div>
                <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
            </div>
            {deletePopup && (
                <div className='img-popup-design'>
                    <div className='img-popup'>
                        <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 text-center">
                            Are you sure, want to Delete?
                        </p>
                        <div className="d-flex ac-jb px-2 mt-5">
                            <button onClick={() => setDeletePopup(false)} className="no-btn">
                                No
                            </button>
                            <button
                                onClick={() => {
                                    bannerDelete(deletePopup); setDeletePopup(false);
                                }}
                                className="yes-btn f2"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Banners